import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  label?: string;
  className?: string;
};
export function CtaButton({
  label = 'Je veux le pack complet — 27 $',
  className = ''
}: CtaButtonProps) {
  return <a href="#offre" className={`group inline-flex w-full max-w-sm items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gold px-5 py-4 text-[15px] font-bold text-ink shadow-[0_10px_30px_rgba(214,163,60,0.25)] transition-[background-color,transform] duration-150 ease-out hover:bg-gold-soft active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:w-auto sm:max-w-none sm:gap-3 sm:px-8 sm:text-base ${className}`} data-id="element-69" data-mp="hlgm3l1meniz">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-70" data-mp="19as38spmr36t" />
    </a>;
}